export const URLAPISUBIDA = 'https://picanteriaipiales.com/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://picanteriaipiales.com/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://picanteriaipiales.com/notis/'

export const URLAPISUBIDAPDF = 'https://picanteriaipiales.com/notis/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://picanteriaipiales.com/notis/'